import { Box, styled } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { AI_GRADIENT_CSS } from 'common/constants/ai';

export const pendingCitationBoxSx: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  cursor: 'pointer',
  // Apply gradient to the text spans rendered by FastValueViewer
  '& .text-cell, & .value-viewer': {
    background: AI_GRADIENT_CSS,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    fontWeight: 500,
  },
};

export const StyledCitationValueViewerWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  padding: '2px 4px',
}));

export const StyledCitationNumber = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '14px',
  width: '16px',
  height: '18px',
  fontSize: '0.6rem',
  fontWeight: 600,
  padding: '0 2px',
  borderRadius: '2px',
  flexShrink: 0,
}));

export const StyledCitationNumberWrapper = styled(Box)(() => ({
  position: 'absolute',
  left: 2,
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  gap: '2px',
  zIndex: 10,
  pointerEvents: 'auto',
}))

export const StyledCitationValueViewer = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
  height: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}))